import { GenIcon } from '../helpers/IconBase.es.js';

const PackagedHamperOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M20.7474 10.4608L20.7428 10.4421L18.1131 3.76006C17.9959 3.38271 17.6467 3.12256 17.2506 3.12256H6.59119C6.19275 3.12256 5.83885 3.3874 5.72635 3.76943L3.26775 10.3835L3.26072 10.3999L3.25604 10.4187C3.22557 10.5335 3.21619 10.6507 3.2326 10.7655C3.23025 10.803 3.22791 10.8405 3.22791 10.878V19.4538C3.22853 19.8316 3.37886 20.1936 3.64597 20.4608C3.91307 20.7279 4.27517 20.8782 4.65291 20.8788H19.3529C20.1381 20.8788 20.7779 20.239 20.7803 19.4538V10.878C20.7803 10.8476 20.7803 10.8171 20.7779 10.7913C20.7873 10.6765 20.7779 10.5663 20.7474 10.4608ZM13.8146 9.45303L13.8076 9.821C13.7888 10.8733 13.0623 11.5812 12.0006 11.5812C11.4826 11.5812 11.0373 11.4147 10.7162 11.0983C10.3951 10.7819 10.2193 10.3413 10.2099 9.821L10.2029 9.45303H5.37947L7.24275 4.92256H16.599L18.5138 9.45303H13.8146ZM5.02557 11.253H8.71229C9.28182 12.5913 10.4935 13.3812 12.0029 13.3812C12.7928 13.3812 13.5263 13.1608 14.1193 12.7437C14.6396 12.378 15.0451 11.8671 15.3076 11.253H18.9756V19.0788H5.02557V11.253Z",
          fill: "#F5222D"
        }
      }
    ]
  })(props);
};

export { PackagedHamperOutlined };
